import {DateTime} from 'luxon';

export const transferDateObj = (d: any) => (d ? new Date(d) : undefined);
export const formatYYYYMMDD = (date?: Date | string) => {
  if (date) {
    return DateTime.fromJSDate(new Date(date)).toFormat('yyyy/MM/dd');
  }
  return '';
};
export function isValidTime(
  time: string | null | undefined,
  is24Hours: boolean = true,
) {
  if (time === null || time === undefined) {
    return false;
  }

  const times = time.split(':').map(n => parseInt(n)); // ?
  if (times.length !== 2 || isNaN(times[0]) || isNaN(times[1])) {
    return false;
  }

  if (times[1] > 59 || times[1] < 0) {
    return false;
  }

  if (is24Hours && (times[0] > 23 || times[0] < 0)) {
    return false;
  }

  if (!is24Hours && (times[0] > 12 || times[0] < 1)) {
    return false;
  }

  return true;
}

export function timeToDateTime(
  time: string,
  crossDateStandard: DateTime = DateTime.now().startOf('day'),
) {
  const times = time.split(':').map(n => parseInt(n));
  let newTime = crossDateStandard.set({
    hour: times[0],
    minute: times[1],
  });

  if (crossDateStandard > newTime) {
    newTime = newTime.plus({days: 1});
  }

  return newTime;
}
